module.exports = __webpack_public_path__ + "static/luis-cc53e6294bd84e9ee08d0f843362f5de.png";